export default __webpack_public_path__ + "static/media/info2.f9d433f0.svg";